import React from 'react'
import PropTypes from 'prop-types'
import { Button, withStyles } from '@material-ui/core'
import classNames from 'classnames'
import {
  Field,
  Form,
  useForm,
  deleteDynamicForm,
  WatchField,
  useWatch
} from '../../form'
import {
  DUE_DATE_FEE,
  PARTIAL_PAY_FEE,
  INTEREST_PERCENT
} from '../../constants'
import FontAwesome from 'react-fontawesome'
import { adminInvoiceFormValidate } from '../../containers/validate'
import { useDispatch, useSelector } from 'react-redux'
import { NumberInput } from '../../utils/numberFormat'
import {
  getIsAdminHalfPaid,
  getIsAdminRejected,
  getIsAdminSent
} from '../../selectors/admin.selectors'

/**
 * @author Huong Nguyen
 */

class AdminInvoiceForm extends React.Component {
  render() {
    return <AdminInvoiceFormComponent {...this.props} />
  }
}

const styles = (theme) => ({
  buttonList: {
    marginRight: '0px !important',
    paddingTop: '0px !important',
    paddingLeft: theme.spacing(2) + 'px !important',
    paddingRight: theme.spacing(2) + 'px !important'
  },
  textField: {
    fontSize: '15px',
    marginTop: theme.spacing(4)
  },
  checkbox: {
    marginTop: theme.spacing(2),
    fontSize: '15px',
    color: '#808080',
    fontWeight: 'bold'
  },
  notes: {
    lineHeight: '150%'
  }
})

const date = new Date()
const defaultValues = {
  due_date_field: date,
  total_sum: 0,
  partial_amount_received: 0,
  left_sum: 0
}

const AdminInvoiceFormComponent = ({
  classes,
  index,
  initialValues,
  uuid,
  base_invoice_id,
  base_uuid,
  dueInvoiceIds,
  updateAdminInvoice,
  updateAdminInvoiceStatusToNew,
  showLatestInvoicePDF,
  setOpen,
  isManualMaksettu
}) => {
  const isAdminSent = useSelector(getIsAdminSent)
  const isAdminHalfPaid = useSelector(getIsAdminHalfPaid)
  const isAdminRejected = useSelector(getIsAdminRejected)

  let initDefVal = {
    ...defaultValues,
    ...replaceNullsWithStrings(initialValues)
  }

  initDefVal.total_sum =
    initialValues.ReminderSent === 1
      ? (
          initialValues.total_sum +
          initialValues.reminderfee +
          initialValues.interestfee
        ).toFixed(2)
      : initialValues.total_sum

  initDefVal.partial_amount_received = initialValues.partial_amount_received

  initDefVal.left_sum =
    initDefVal.total_sum - initDefVal.partial_amount_received

  initDefVal.due_date_field =
    initialValues.ReminderSent === 1
      ? initialValues.reminder_due_date
      : initialValues.due_date

  const form = useForm({
    name: 'adminInvoiceForm' + index,
    onSubmit: onSubmit,
    defaultValues: initDefVal,
    resetOnSubmit: false,
    validator: (values) => adminInvoiceFormValidate(values, isManualMaksettu)
  })

  function onSubmit(values) {
    if (isManualMaksettu) {
      const shouldUpdateStatus = initDefVal.status === 7 && values.left_sum > 0
      shouldUpdateStatus
        ? updateAdminInvoice(values)
        : updateAdminInvoiceStatusToNew(
            isAdminSent || isAdminHalfPaid || isAdminRejected ? 18 : 2,
            values.notes
          )
    } else {
      updateAdminInvoice(values)
    }
  }

  const { control } = form
  const dispatch = useDispatch()

  // set value
  function setValue(name, value) {
    form?.setValue(name, value)
  }

  // total_sum after reminder sent
  let reminderTotalSum =
    initialValues.ReminderSent === 1
      ? initialValues.total_sum +
        initialValues.reminderfee +
        initialValues.interestfee
      : initialValues.total_sum

  // minDate, maxDate
  let dueDate =
    initialValues.ReminderSent === 1
      ? initialValues.reminder_due_date
      : initialValues.due_date
  let dateX = new Date(dueDate.valueOf())
  let endDueDate = new Date(dateX.setDate(dateX.getDate() + parseInt(14)))

  // implement left_sum
  let { partial_amount_received } = useWatch({
    fields: 'partial_amount_received',
    control
  })

  let left_sum =
    reminderTotalSum -
      parseFloat(partial_amount_received.toString().replace(/,/g, '.')) >
    0
      ? reminderTotalSum -
        parseFloat(partial_amount_received.toString().replace(/,/g, '.'))
      : 0

  // if maksettu
  if (initialValues.status === 2) {
    left_sum = 0
  }

  // Close expand row
  const closeRow = () => {
    setOpen(false)
    dispatch(deleteDynamicForm('adminInvoiceForm' + index))
  }

  return (
    <div className={classes.container}>
      <Form {...form}>
        <div className="row">
          <div className="dashboard-content-header">
            <div className="col-xs-12 col-sm-6 col-lg-4">
              <div
                className="panel"
                style={{
                  border: '1px solid #D3D3D3',
                  height: '470px'
                }}
              >
                <div className="panel-heading">
                  <h3 className="panel-title">{'Alkuperäinen lasku'}</h3>
                </div>
                <div className="panel-body" style={{ marginBottom: '25px' }}>
                  {dueInvoiceIds &&
                    dueInvoiceIds.map((Id, i) => (
                      <p
                        key={i}
                        values={Id}
                        style={{
                          display: 'inline-block',
                          marginTop: '16px',
                          marginRight: '8px',
                          color: '#44c0cc'
                        }}
                        onClick={() =>
                          showLatestInvoicePDF(
                            Id,
                            uuid,
                            base_invoice_id,
                            base_uuid
                          )
                        }
                      >
                        <FontAwesome
                          name="file-pdf-o"
                          size="2x"
                          title={`Lasku_${Id}.pdf`}
                        />
                      </p>
                    ))}
                  <Field
                    name="total_sum"
                    inputType="textfield"
                    label="Summa €"
                    className={classNames(classes.textField, classes.resize)}
                    disabled={true}
                    control={control}
                    inputComponent={FixedNumberInput}
                  />
                  <WatchField control={control} fields={['total_sum']}>
                    {(watch) => (
                      <Field
                        name="partial_amount_received"
                        inputType="textfield"
                        label="Maksettu summa €"
                        className={classNames(
                          classes.textField,
                          classes.resize
                        )}
                        inputComponent={FixedNumberInput}
                        control={control}
                        onChange={(e) => {
                          const val = e.target.value
                          setValue('left_sum', watch.total_sum - val)
                        }}
                        disabled={
                          isManualMaksettu ||
                          initialValues.instant_payment === 'quick_pay' ||
                          (initialValues.instant_payment !== 'quick_pay' &&
                            initialValues.status !== 1 &&
                            initialValues.status !== 13 &&
                            initialValues.status !== 7) ||
                          initialValues.is_group_invoice
                            ? true
                            : false
                        }
                      />
                    )}
                  </WatchField>
                  <Field
                    name="left_sum"
                    inputType="textfield"
                    label="Jäljelle jäävä summa €"
                    className={classNames(classes.textField, classes.resize)}
                    disabled={true}
                    inputComponent={FixedNumberInput}
                    control={control}
                  ></Field>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-4">
              <div
                className="panel"
                style={{
                  border: '1px solid #D3D3D3',
                  height: '470px'
                }}
              >
                <div className="panel-heading">
                  <h3 className="panel-title">{'Laskun lisämaksutiedot'}</h3>
                </div>
                <div className="panel-body" style={{ marginBottom: '25px' }}>
                  <Field
                    name="due_date_field"
                    inputType="datepicker"
                    label="Eräpäivä"
                    control={control}
                    textFieldStyle={{ width: '100%' }}
                    className={classes.textField}
                    minDate={new Date(dueDate)}
                    maxDate={new Date(endDueDate)}
                    disabled={
                      isManualMaksettu ||
                      initialValues.instant_payment === 'quick_pay' ||
                      (initialValues.instant_payment !== 'quick_pay' &&
                        initialValues.status !== 1 &&
                        initialValues.status !== 13 &&
                        initialValues.status !== 7) ||
                      initialValues.is_group_invoice
                        ? true
                        : false
                    }
                  />
                  <Field
                    name="due_date_fee"
                    label={`Eräpäivä maksu ${DUE_DATE_FEE} €`}
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={
                      isManualMaksettu ||
                      initialValues.instant_payment === 'quick_pay' ||
                      (initialValues.instant_payment !== 'quick_pay' &&
                        initialValues.status !== 1 &&
                        initialValues.status !== 13 &&
                        initialValues.status !== 7) ||
                      initialValues.is_group_invoice
                        ? true
                        : left_sum === 0
                        ? true
                        : false
                    }
                  />
                  <Field
                    name="partial_pay_fee"
                    label={`Osittainen maksu ${PARTIAL_PAY_FEE} €`}
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={
                      isManualMaksettu ||
                      initialValues.instant_payment === 'quick_pay' ||
                      (initialValues.instant_payment !== 'quick_pay' &&
                        initialValues.status !== 1 &&
                        initialValues.status !== 13 &&
                        initialValues.status !== 7) ||
                      initialValues.is_group_invoice
                        ? true
                        : left_sum > 0 && left_sum != reminderTotalSum
                        ? false
                        : true
                    }
                  />
                  <Field
                    name="interest_fee"
                    label={`Korko ${INTEREST_PERCENT} %`}
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={
                      isManualMaksettu ||
                      initialValues.instant_payment === 'quick_pay' ||
                      (initialValues.instant_payment !== 'quick_pay' &&
                        initialValues.status !== 1 &&
                        initialValues.status !== 13 &&
                        initialValues.status !== 7) ||
                      initialValues.is_group_invoice
                        ? true
                        : left_sum === 0
                        ? true
                        : false
                    }
                  />
                  <WatchField control={control} fields={['left_sum']}>
                    {(watch) => (
                      <Field
                        name="send_new_invoice"
                        label="Lähetä uusi lasku"
                        inputType="checkbox"
                        className={classes.checkbox}
                        control={control}
                        disabled={
                          initialValues.status === 7 &&
                          watch.left_sum > 0 &&
                          initialValues.instant_payment !== 'quick_pay'
                            ? false
                            : isManualMaksettu ||
                              initialValues.instant_payment === 'quick_pay' ||
                              (initialValues.instant_payment !== 'quick_pay' &&
                                initialValues.status !== 1 &&
                                initialValues.status !== 13 &&
                                initialValues.status !== 7) ||
                              initialValues.is_group_invoice
                            ? true
                            : left_sum == 0
                            ? true
                            : false
                        }
                      />
                    )}
                  </WatchField>
                  <Field
                    name="send_qp_admin_invoice"
                    label="Lähetä admin lasku (QP)"
                    inputType="checkbox"
                    className={classes.checkbox}
                    control={control}
                    disabled={
                      !isManualMaksettu ||
                      (initialValues.instant_payment === 'quick_pay' &&
                        initialValues.status === 7 &&
                        left_sum > 0 &&
                        initialValues.isQPFee &&
                        !initialValues.is_group_invoice)
                        ? false
                        : true
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-lg-4">
              <div
                className="panel"
                style={{
                  border: '1px solid #D3D3D3',
                  height: '470px'
                }}
              >
                <div className="panel-heading">
                  <h3 className="panel-title">{'Laskun lisätiedot'}</h3>
                </div>
                <div className="panel-body" style={{ marginBottom: '25px' }}>
                  <Field
                    name="notes"
                    inputType="textfield"
                    label="Lisäkommentit"
                    className={classNames(
                      classes.textField,
                      classes.resize,
                      classes.notes
                    )}
                    multiline
                    control={control}
                    disabled={
                      initialValues.status === 21 || initialValues.status === 22
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row button-align">
              <ul
                className={classNames(
                  classes.buttonList,
                  'button-container nav nav-pills pull-right'
                )}
              >
                <li className="button-list">
                  <Button
                    variant="contained"
                    className="button-fill"
                    onClick={closeRow}
                  >
                    Peruuta
                  </Button>
                </li>
                <li className="button-list">
                  <Button
                    variant="contained"
                    className="button-fill"
                    type="submit"
                  >
                    Tallenna ja Lähetä
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Form>
    </div>
  )
}

function replaceNullsWithStrings(obj) {
  const newObj = {}
  Object.keys(obj).forEach((key) => {
    newObj[key] = obj[key] === null ? '' : obj[key]
  })
  return newObj
}

const FixedNumberInput = (props) => {
  return <NumberInput {...props} decimalScale={2} fixedDecimalScale={false} />
}

AdminInvoiceForm.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AdminInvoiceForm)
